module.exports = __webpack_public_path__ + "img/a7.a68624ca.jpeg";